import { Star, Zap } from "lucide-react";

// Coming Soon Badge Component
type Props = {
  className?: string;
};

const ComingSoonBadge = ({ className }: Props) => {
  return (
    <div className={`fixed  z-50 ${className} ease-in-out duration-500`}>
      <div className="relative group">
        {/* Glow Effect */}
        <div className="absolute -inset-1 bg-gradient-to-r from-purple-600 to-pink-600 rounded-xl blur opacity-75 group-hover:opacity-100 transition duration-1000 group-hover:duration-200 animate-pulse"></div>

        {/* Main Badge */}
        <div className="relative bg-gradient-to-br from-purple-500 to-pink-600 rounded-xl shadow-2xl transform -rotate-3 group-hover:rotate-0 transition-all duration-500">
          {/* Badge Content */}
          <div className="px-4 py-3 border-2 border-white/20 rounded-xl backdrop-blur-sm">
            {/* Check Icon Circle */}
            <div className="flex items-center justify-center mb-2">
              <div className="relative">
                <div className="w-8 h-8 bg-white rounded-full flex items-center justify-center shadow-lg">
                  <div className="w-6 h-6 bg-purple-500 rounded-full flex items-center justify-center animate-pulse">
                    <svg
                      className="w-4 h-4 text-white"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={3}
                        d="M5 13l4 4L19 7"
                      ></path>
                    </svg>
                  </div>
                </div>
                {/* Decorative stars */}
                <Star
                  className="absolute -top-1 -right-1 w-3 h-3 text-yellow-400 fill-current animate-spin"
                  style={{ animationDuration: "3s" }}
                />
                <Zap className="absolute -bottom-0.5 -left-1 w-2.5 h-2.5 text-yellow-300 fill-current animate-bounce" />
              </div>
            </div>

            {/* Badge Text */}
            <div className="text-center">
              <h2 className="text-sm font-black text-white mb-1 transform group-hover:scale-110 transition-transform duration-300">
                COMING SOON
              </h2>
              <div className="bg-purple-600/80 px-2 py-1 rounded backdrop-blur-sm">
                <p className="text-white font-bold text-xs tracking-wider">
                  NEW FEATURE
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ComingSoonBadge;
